import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import ProductCard from "../components/ProductCard/ProductCard"
import Footer from "../components/Footer/Footer"
import PageHeader from '../components/PageHeader/PageHeader'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'

function Wishlist() {
      const { currentLocal } = useSelector((state) => state.currentLocal);
    
  return (
    <>
      <Navbar />
      <PageHeader title={currentLocal?.home?.Wishlist} />
      <Container className='my-5'>
        <Row>
          <Col md={3}>
            <ProductCard img={'https://cdn.tozlu.com/img/640/85/kadin-dik-yaka-fermuarli-polar-sweatshirt-1b208-11e411.webp'} />
          </Col>
          <Col md={3}>
            <ProductCard
              img={'https://plus.unsplash.com/premium_photo-1674719144570-0728faf14f96?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            />
          </Col>
          <Col md={3}>
            <ProductCard
              img={'https://plus.unsplash.com/premium_photo-1671030274122-b6ac34f87b8b?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            />
          </Col>    <Col md={3}>
            <ProductCard img={'https://cdn.tozlu.com/img/640/85/kadin-dik-yaka-fermuarli-polar-sweatshirt-1b208-11e411.webp'} />
          </Col>    <Col md={3}>
            <ProductCard img={'https://cdn.tozlu.com/img/640/85/kadin-dik-yaka-fermuarli-polar-sweatshirt-1b208-11e411.webp'} />
          </Col>
        </Row>
      </Container>
      <Footer />
    </>

  )
}

export default Wishlist